import { MenuData, SubMenuData } from './menuTypes';

export const hasActiveSubMenu = (pathname: string, item: MenuData) =>
  item.subItems?.some(subItem => isSubMenuActive(pathname, subItem)) ?? false;

export const isSubMenuActive = (pathname: string, subItem: SubMenuData) =>
  (subItem.url === pathname || subItem.activeForUrls?.includes(pathname)) ?? false;
